import { PropsWithChildren } from 'react';

import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface ConfirmModalProps {
  body: string;
  cancelIcon?: FAIconName;
  cancelLabel: string;
  confirmIcon?: FAIconName;
  confirmLabel: string;
  confirmVariant?: 'accent.critical' | 'primary';
  id?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
}

const ConfirmModal = ({
  body,
  cancelIcon,
  cancelLabel,
  children,
  confirmIcon,
  confirmLabel,
  confirmVariant = 'primary',
  id = 'confirm-modal',
  isDisabled,
  isLoading,
  isOpen,
  onClose,
  onConfirm,
  title,
}: PropsWithChildren<ConfirmModalProps>) => (
  <ModalV2
    bodyOverflow="unset"
    id={id}
    footerContent={
      <ChakraFlex
        alignItems="center"
        justifyContent="space-between"
        marginTop="24px"
        width="100%"
      >
        <FireflyButton
          id={`${id}__${cancelLabel}`}
          leftIcon={cancelIcon}
          onClick={onClose}
          variant="secondary"
        >
          {cancelLabel}
        </FireflyButton>
        <FireflyButton
          id={`${id}__${confirmLabel}`}
          isDisabled={isDisabled}
          isLoading={isLoading}
          leftIcon={confirmIcon}
          onClick={onConfirm}
          variant={confirmVariant}
        >
          {confirmLabel}
        </FireflyButton>
      </ChakraFlex>
    }
    isOpen={isOpen}
    onClose={onClose}
    title={title}
  >
    <Text>{body}</Text>
    {children}
  </ModalV2>
);

export default ConfirmModal;
